function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.38667 10.3933L11.1133 8.66667H4.66667V7.33333H11.1133L9.38667 5.60667L10.3333 4.66667L13.6667 8L10.3333 11.3333L9.38667 10.3933ZM12.6667 2C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V6.44667L12.6667 5.11333V3.33333H3.33333V12.6667H12.6667V10.8867L14 9.55333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.59333 14 2 13.4 2 12.6667V3.33333C2 2.59333 2.59333 2 3.33333 2H12.6667Z",
  fill: "currentColor"
});
function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "static/2.5.1/media/logout.362e7cc0.svg";
export { SvgLogout as ReactComponent };